export default "__VITE_ASSET__CIj3_6L0__"